 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		58: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + chunkId + "." + {"0":"36af6b0f9c5a0a2d3369","1":"81037bc57103e5670ef0","2":"442f6390de12cacb3cb6","3":"062b6ddc7e2a40aa3998","4":"951f400bed27ee505260","5":"9dfdadd2ae0512c758d9","6":"91f5e517c45ccb3ab845","7":"4ddd4d3fc293238b3e56","8":"689b4c766ecd279e8421","9":"4ac84e552c0fdee4dd08","10":"fd96db39710960c20eff","11":"f15ae0b098776acef6bd","12":"4823bbf301f1d78a38ea","13":"69171a4dbbadb10c7114","14":"416cab6676c67541ee0c","15":"42957113d81512820b02","16":"1538243b7e8ac9c727d5","17":"af5d36e401b385557f6a","18":"49e818252a22a11a6105","19":"c2352a121e2091b41486","20":"131451dcb980f604bb3f","21":"5788e04a9c56cb7ffbce","22":"8095fafb89a623e288fd","23":"da819632019bcecaf4be","24":"5dd6134274f21cf38b9b","25":"e5fb44803127dbcbe38d","26":"72ade291c21bcd121ac7","27":"9b0ede6e5662dcfe52e8","28":"10fb56579759f772cbf8","29":"b343f5b6db748a2be0c9","30":"92d3a24d3aec9eeda05f","31":"add5aa9498a81e6a5a8c","32":"43814f0754a5ea846177","33":"99443695df94030a3e69","34":"e04eb9d95b3e3a51e83a","35":"dc60db2c6f53c895e8c6","36":"54400b733d0cc6ae289f","37":"7e246513f57e697067ff","38":"d3d9bbd802362df30a4f","39":"2d6f66ce66615d675eea","40":"cb22c03d27925d1fff2a","43":"63070e0c23016ee0d867","44":"32fe6c440437d49f86de","45":"0e9b1885b45c64c3905e","46":"16e0a48a600ee0da9f58","47":"3db723994c9bee5c4441","48":"bce31048e519c021b243","49":"4f570ab5e5e2a3b2361d","50":"320fdb389cae14d35935","51":"78e41ead3e165b432b58","52":"80897892055a6812dc8d","53":"1ae538c773104941a5ec","54":"15e84abe526457ab392d","55":"1f1389260bc5c51267d9","56":"9157ee24a10b97dcc57f","57":"c14e07dbfa98d96ab9b2","60":"95c77284429939c29a16","61":"a24712f1f7a26b4d9841","62":"e6e2b8287647cf1b6a29","63":"b80ec51430b1f5e281da","64":"a0347c87a0a2b869bc2f","65":"90c096acc8029cf3c81d","66":"606466749b0e28f48681","67":"743d9f5358c1d78f7d1f","68":"3626ec13bc4bebd898c3","69":"175ac9363c83460af7bf","70":"345f1c34dfc3c5dce6f8","71":"0d63641675a24e8dfd0b","72":"a44b8f2c41e9251bd11f","73":"80fc742a658cb35fd251","74":"083b109eb4a02c06aa18","75":"08a94c6093165ab6ccda","76":"5cc8d68bf863fee159e8","77":"a9015fefc0af17741627","78":"a9e3f35fbc93227b8709","79":"275a3f5ac407fb05c3a0","80":"7af7dc8f987845aa4ef6","81":"b37ab086edf3af0df722","82":"bc954148073af14fc255","83":"f950d33d1f28419cc225","84":"5135d531b1585534c4c0","85":"c3135b72067e91fd9df4"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.catalog.prod.coursedog.com/80c7da4/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
